import { useHistory } from "react-router-dom";
import { useState } from "react";
import CryptoJS from "crypto-js";
import { properties as propertiesCloudConfig, getUrl } from "config/Config";
import { cruds, nuevoUsuario } from "./altaUsuarioConContrasenaData";
import RestProvider from "providers/RestProvider";
import AuthProvider from "providers/authProvider";
import FormioProvider from "providers/FormioProvider";

const useOperations = () => {
  const { crudOperation, crudOperationsType } = RestProvider();
  const history = useHistory();
  const [message, setMessage] = useState({ msg: "", severity: "" });
  let _ID = 0;
  const addAlert = (msg) => setAlerts([...alerts, { id: _ID++, msg }]);
  const [alerts, setAlerts] = useState([]);
  const handleSetMessage = (msg, severity) => {
    setMessage({ msg, severity });
    addAlert(message);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
  const irAccesoConContraseña = () => { history.push("/AccesoConContrasena") }
  const [formData, setFormData] = useState();
  const { formioOperation } = FormioProvider();

  // Credenciales de usuario con permisos necesarios para realizar el alta de usuario
  const username = propertiesCloudConfig["KEYCLOAK_AUTH_ACCESO_USERNAME"];
  const password = propertiesCloudConfig["KEYCLOAK_AUTH_ACCESO_PASSWORD"];
  const { login } = AuthProvider();
  const loginAccess = () => { login(username, password, false) };


  /**
   * @function getForm Método que obtiene el recurso de formio
   * @param {*} aliasFormulario Recibe el alias del formulario
   */
  const getResource = async (aliasFormulario) => {
      formioOperation('altaUsuarioConContrasena', {}, false).then(response => {
          setFormData(response.data);
      })
  }

  /**
   * @function handleOnSubmit Función que se ejecutará cuando se produzca en el formulario el evento onSubmit
   */
  const handleOnSubmit = async (data) => {
    setIsLoading(true);
    let usuario = {};

    // Paso 1. Se construye el objeto que requiere el endpoint recibir por parámetros
    let obj = await buildObjNuevoUsuario(data);

    // Paso 2. Se realiza la creación del usuario
    crudOperation(crudOperationsType.CUSTOM, cruds.altaUsuario.resource, {
      url: cruds.altaUsuario.url,
      method: "post",
      data: obj,
    })
      .then((response) => {
        usuario = response.data;
        setIsLoading(false);
        setMostrarConfirmacion(true)
      })
      .catch(function (error) {
        if (error.response && error.response.status === 400) {
          handleSetMessage("Ha ocurrido un error al crear el usuario", "error");
        } else if (error.response && error.response.status === 401) {
          handleSetMessage("El pasaporte ya existe. Revise los datos y envíe de nuevo.", "error");
        } else if (error.response && error.response.status === 404) {
          handleSetMessage("El correo ya existe. Revise los datos y envíe de nuevo.", "error");
        } else {
          // En caso de otros errores, manejar según sea necesario
          console.error("Error desconocido:", error);
        }
        setIsLoading(false);
      });
    return usuario;
  };

  /**
   * @constant buildObjNuevoUsuario Constante dónde se crea el objeto que necesitará la función handleOnSubmit 
   * para el endpoint de creación del usuario
   * @param {*} data
   * @returns
   */
  const buildObjNuevoUsuario = async (data) => {
    let interesado = data.data.containerPersonales;
    let contacto = data.data.containerDireccion;
    let inputPassword = data.data.containerContrasena;

    nuevoUsuario.identificador = interesado.pasaporte;
    nuevoUsuario.contrasena = hashPassword(inputPassword.contrasena);
    nuevoUsuario.interesadoDto.nombre = interesado.nombre;
    nuevoUsuario.interesadoDto.apellido1 = interesado.primerApellido;
    nuevoUsuario.interesadoDto.apellido2 = interesado.segundoApellido;
    nuevoUsuario.interesadoDto.identificador = interesado.pasaporte;
    nuevoUsuario.interesadoDto.sexo = interesado.sexo;
    nuevoUsuario.interesadoDto.fechaNacimiento = interesado.fechaNacimiento.split('T')[0];
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.email = interesado.correoElectronico;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.telefono = interesado.telefonoFijo;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.telefonoMovil = interesado.telefonoMovil;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.tipoVia = await getTipoVia(contacto.tipoDeVia);
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.nombreVia = contacto.nombreDeLaVia;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.numero = contacto.numero;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.piso = contacto.piso;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.puerta = contacto.puerta;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.letra = contacto.letra;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.escalera = contacto.escalera;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.idPais = contacto.pais;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.pais = { id: contacto.pais };
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.postal = contacto.codigoPostal;
    nuevoUsuario.interesadoDto.datosContactoPorDefecto.tipoInteresado = await getTipoInteresado('SOLICITANTE');
    // El formulario no cuenta con los campos Provincia / Municipio, pero podría cambiar
    if (contacto.provincia) {
      nuevoUsuario.interesadoDto.datosContactoPorDefecto.idProvincia = contacto.provincia;
      nuevoUsuario.interesadoDto.datosContactoPorDefecto.provincia = { id: contacto.provincia };
    }
    if (contacto.municipio) {
      nuevoUsuario.interesadoDto.datosContactoPorDefecto.idMunicipio = contacto.municipio;
      nuevoUsuario.interesadoDto.datosContactoPorDefecto.municipio = { id: contacto.municipio };
    }

    return { ...nuevoUsuario };
  };

  /**
   * @function handleCustomEvents Función que captura los eventos de los botones customizados
   * @param {*} customEvent
   */
  const handleCustomEvents = (customEvent) => {
    // Captura cuando se hace click sobre el botón Atrás
    if (customEvent.type === "btnAtras") {
      irAccesoConContraseña();
    }
  };

  /**
   * @function getTipoVia Función que obtiene un tipo de vía a partir de su código
   * @param {*} codigo
   * @returns
   */
  const getTipoVia = async (codigo) => {
    let res = null;
    await crudOperation(crudOperationsType.CUSTOM, cruds.tipoVia.resource, {
      url: cruds.tipoVia.url + codigo,
      method: "get",
    })
      .then((response) => {
        res = response.data;
      })
      .catch(function (error) {
        handleSetMessage(
          "Ha ocurrido un error al intentar obtener el tipo de vía.",
          "error"
        );
      });
    return res;
  };
  
  /**
     * @function getTipoInteresado Función que obtiene un tipo de interesado a partir de su código
     * @param {*} codigo 
     * @returns 
     */
  const getTipoInteresado = async (codigo) => {
    let res = null;
    await crudOperation(crudOperationsType.CUSTOM, cruds.tipoInteresado.resource, { url: cruds.tipoInteresado.url + codigo, method: 'get' }).then(response => {
        res = response.data;
    }).catch(function (error) {
        handleSetMessage("Ha ocurrido un error al intentar obtener el tipo de interesado.", 'error');
    });
    return res;
  }
  
  /**
   * @function hashPassword Función que obtiene el hash256 de la contraseña suministrada por el usuario
   * @param {*} password
   * @returns
   */
  const hashPassword = (password) => {
    const hash = CryptoJS.SHA256(password);
    const hexHash = hash.toString(CryptoJS.enc.Hex);
    return hexHash;
  };

  /**
     * Obtiene el valor de la información del usuario almacenada en sesión
     * @param {*} campo 
     * @returns 
     */
  const obtenerUrlContexto = async () => {
    let url = getUrl();
    return url;
  }
  
  return {
    handleOnSubmit,
    handleCustomEvents,
    isLoading,
    alerts,
    message,
    setMessage,
    loginAccess,
    mostrarConfirmacion,
    irAccesoConContraseña,
    formData,
    getResource,
    obtenerUrlContexto
  };
};

export default useOperations;
